/* eslint-disable react-hooks/rules-of-hooks */
import type { AxisSetExtremesEventObject, Axis } from "highcharts";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import flatten from "lodash/flatten";

export default function afterSetExtremes({ chart }: Axis, event: AxisSetExtremesEventObject): void {
  if (chart.series.length === 0 || chart.yAxis.length === 0) {
    return;
  }

  chart.yAxis.forEach((axis) => {
    const points = flatten(axis.series.map((series) => series.points)).filter(
      (node) => node.x >= event.min && node.x <= event.max,
    );

    const values = points.map((node) => node.y).filter(notUndefinedOrNull);

    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    const currentExtremes = axis.getExtremes();

    if (minValue === currentExtremes.min && maxValue === currentExtremes.max) {
      return;
    }

    axis.setExtremes(minValue, maxValue);
  });
}
